import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Trophy, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { formatMonthYearAU } from '../utils/dateFormat';

const API = process.env.REACT_APP_BACKEND_URL;

const CompetitionWinner = () => {
  const [winner, setWinner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLatestWinner();
  }, []);

  const fetchLatestWinner = async () => {
    try {
      const response = await axios.get(`${API}/api/competition/latest-winner`);
      setWinner(response.data.winner);
    } catch (error) {
      console.log('No winner data available');
    } finally {
      setLoading(false);
    }
  };

  if (loading || !winner) {
    return null; // Don't show anything if no winner yet
  }

  return (
    <section className="py-8 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Winner Info */}
          <div className="flex items-center gap-6">
            <div className="bg-white/20 p-4 rounded-full">
              <Trophy className="w-12 h-12 text-white" />
            </div>
            <div className="text-center lg:text-left">
              <p className="text-white/80 text-sm font-medium uppercase tracking-wide">
                Australia's Sexiest Truck of the Month
              </p>
              <h3 className="text-2xl lg:text-3xl font-bold text-white">
                {formatMonthYearAU(winner.competition_month)} Winner
              </h3>
              <p className="text-white text-lg">
                <span className="font-bold">{winner.winner_name}</span>
                {winner.company_name && <span> - {winner.company_name}</span>}
              </p>
              {winner.truck_description && (
                <p className="text-white/90 text-sm">{winner.truck_description}</p>
              )}
              <p className="text-white/80 text-sm mt-1">
                🏆 {winner.total_votes} votes
              </p>
            </div>
          </div>

          {/* Winner Photo */}
          <div className="relative">
            {winner.photo_base64 ? (
              <div className="w-48 h-32 lg:w-64 lg:h-40 rounded-lg overflow-hidden shadow-xl border-4 border-white">
                <img
                  src={`data:image/jpeg;base64,${winner.photo_base64}`}
                  alt={winner.truck_description || 'Winning Truck'}
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="w-48 h-32 lg:w-64 lg:h-40 rounded-lg bg-white/20 flex items-center justify-center">
                <Trophy className="w-16 h-16 text-white/50" />
              </div>
            )}
            <div className="absolute -top-2 -right-2 bg-white text-yellow-600 rounded-full p-2 shadow-lg">
              <Trophy className="w-6 h-6" />
            </div>
          </div>

          {/* CTA */}
          <div className="text-center lg:text-right">
            <Link to="/truck-competition">
              <Button className="bg-white text-yellow-600 hover:bg-yellow-50 font-bold px-6 py-3 shadow-lg">
                Enter This Month's Competition
                <ChevronRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <p className="text-white/80 text-xs mt-2">Vote for your favourite truck!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompetitionWinner;
